<div class="container-fluid">
  <div class="page-title">
    <div class="row">
      <div class="col-6">
        <h3>Configurações</h3>
      </div>
      <div class="col-6">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a routerLink="/dashboard/default">
              <i class="feather icon-home"></i>
              Painel
            </a>
          </li>
          <li class="breadcrumb-item active">Configurações</li>
        </ol>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-10 col-lg-12 mx-auto">
      <div class="card">
        <div class="card-header">
          <h5><i class="feather icon-settings"></i>Configurações do Perfil</h5>
        </div>
        <div class="card-body">
          <div *ngIf="!userData" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-3">Carregando dados do perfil...</p>
          </div>

          <div *ngIf="userData">
            <form [formGroup]="configForm" (ngSubmit)="atualizarUsuario()">
              <!-- Seção: Dados Pessoais -->
              <div class="form-section">
                <h6 class="section-title">Dados Pessoais</h6>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Nome Completo <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite seu nome completo"
                        formControlName="nome"
                      />
                      <div
                        *ngIf="
                          configForm.controls.nome.touched &&
                          configForm.controls.nome.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Nome é obrigatório
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="email"
                        placeholder="Digite seu email"
                        formControlName="email"
                      />
                      <div
                        *ngIf="
                          configForm.controls.email.touched &&
                          configForm.controls.email.errors?.email
                        "
                        class="text text-danger mt-1"
                      >
                        Email inválido
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Telefone <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite seu telefone"
                        formControlName="telefone"
                        mask="(00) 00000-0000"
                      />
                      <div
                        *ngIf="
                          configForm.controls.telefone.touched &&
                          configForm.controls.telefone.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Telefone é obrigatório
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >CPF ou CNPJ <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite seu CPF ou CNPJ"
                        formControlName="cpf_cnpj"
                        (input)="onCpfCnpjInput($event)"
                        maxlength="18"
                      />
                      <div
                        *ngIf="
                          configForm.controls.cpf_cnpj.touched &&
                          configForm.controls.cpf_cnpj.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        CPF ou CNPJ é obrigatório
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Rua <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite sua rua"
                        formControlName="rua"
                      />
                      <div
                        *ngIf="
                          configForm.controls.rua.touched &&
                          configForm.controls.rua.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Rua é obrigatória
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Número <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite o número"
                        formControlName="numero"
                      />
                      <div
                        *ngIf="
                          configForm.controls.numero.touched &&
                          configForm.controls.numero.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Número é obrigatório
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Bairro <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite o bairro"
                        formControlName="bairro"
                      />
                      <div
                        *ngIf="
                          configForm.controls.bairro.touched &&
                          configForm.controls.bairro.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Bairro é obrigatório
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Cidade <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite a cidade"
                        formControlName="cidade"
                      />
                      <div
                        *ngIf="
                          configForm.controls.cidade.touched &&
                          configForm.controls.cidade.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Cidade é obrigatória
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label"
                        >Pix <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        formControlName="pix"
                        placeholder="Digite o seu pix"
                      />
                      <div
                        *ngIf="
                          configForm.controls.pix.touched &&
                          configForm.controls.pix.errors?.required
                        "
                        class="text text-danger mt-1"
                      >
                        Pix é obrigatório
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Seção: Segurança -->
              <div class="form-section">
                <h6 class="section-title">Segurança</h6>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Nova Senha (opcional)</label>
                      <input
                        class="form-control"
                        type="password"
                        placeholder="Deixe em branco para manter a atual"
                        formControlName="senha"
                        autocomplete="new-password"
                        readonly
                        (focus)="$event.target.removeAttribute('readonly')"
                      />
                      <div
                        *ngIf="
                          configForm.controls.senha.touched &&
                          configForm.controls.senha.errors?.minlength
                        "
                        class="text text-danger mt-1"
                      >
                        Senha deve ter no mínimo 6 caracteres
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Confirmar Nova Senha</label>
                      <input
                        class="form-control"
                        type="password"
                        placeholder="Confirme a nova senha"
                        formControlName="confirmarSenha"
                        autocomplete="new-password"
                        readonly
                        (focus)="$event.target.removeAttribute('readonly')"
                      />
                      <div
                        *ngIf="
                          configForm.controls.confirmarSenha.touched &&
                          configForm.controls.confirmarSenha.errors
                            ?.passwordMismatch
                        "
                        class="text text-danger mt-1"
                      >
                        As senhas não coincidem
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Seção: Informações do Sistema -->
              <div class="form-section">
                <h6 class="section-title">Informações do Sistema</h6>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Login</label>
                      <input
                        class="form-control"
                        type="text"
                        [value]="userData.login"
                        readonly
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Representante ID</label>
                      <input
                        class="form-control"
                        type="text"
                        [value]="userData.ref_representante"
                        readonly
                        disabled
                        style="
                          font-family: 'Courier New', monospace;
                          font-size: 13px;
                        "
                      />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">
                        <i class="feather icon-percent"></i>
                        Comissão do Representante
                      </label>
                      <input
                        class="form-control"
                        type="text"
                        [value]="
                          userData.comissao_representante
                            ? userData.comissao_representante + '%'
                            : '0%'
                        "
                        readonly
                        disabled
                        style="
                          font-family: 'Courier New', monospace;
                          font-size: 13px;
                          text-align: center;
                        "
                      />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Status</label>
                      <div
                        class="status-badge"
                        [ngClass]="
                          userData.ativo ? 'status-active' : 'status-inactive'
                        "
                      >
                        <i
                          [ngClass]="
                            userData.ativo
                              ? 'feather icon-check-circle'
                              : 'feather icon-x-circle'
                          "
                        ></i>
                        {{ userData.ativo ? "Ativo" : "Inativo" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Seção: Link de Divulgação -->
              <div class="form-section">
                <h6 class="section-title">
                  <i class="feather icon-share-2"></i>
                  Link de Divulgação
                </h6>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label">
                        <i class="feather icon-link"></i>
                        Seu Link de Divulgação
                      </label>
                      <div class="link-container">
                        <div class="link-preview">
                          <span class="link-prefix"
                            >https://painel.japedido.com.br/plano?ref=</span
                          >
                          <span class="link-ref">{{
                            userData.ref_representante
                          }}</span>
                        </div>
                        <button
                          type="button"
                          class="btn btn-copy"
                          (click)="copiarLink()"
                          [disabled]="copiando"
                          [ngClass]="copiando ? 'copied' : ''"
                        >
                          <i *ngIf="!copiando" class="feather icon-copy"></i>
                          <i *ngIf="copiando" class="feather icon-check"></i>
                          <span class="btn-text">{{
                            copiando ? "Copiado!" : "Copiar Link"
                          }}</span>
                        </button>
                      </div>
                      <div class="link-info">
                        <div class="info-item">
                          <i class="feather icon-info"></i>
                          <span
                            >Use este link para divulgar e ganhar
                            comissões</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      [disabled]="!configForm.valid || loading"
                    >
                      <span
                        *ngIf="loading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                      <i *ngIf="!loading" class="feather icon-save"></i>
                      {{ loading ? "Salvando..." : "Salvar Alterações" }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
